import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

function Root() {
  useEffect(() => {
    const hideBadge = () => {
      const candidates = [
        document.getElementById("emergent-badge"),
        ...Array.from(document.querySelectorAll('[aria-label="Made with Emergent"]')),
        ...Array.from(document.querySelectorAll('a[href*="emergentagent.com"]')),
        ...Array.from(document.querySelectorAll('iframe[src*="emergent" i]')),
      ];
      candidates.forEach((el) => {
        if (el) { el.style.display = "none"; el.style.opacity = "0"; el.style.pointerEvents = "none"; }
      });
    };
    hideBadge();
    const mo = new MutationObserver(hideBadge);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => mo.disconnect();
  }, []);
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
